import { render } from "./RankThisweekComponent.vue?vue&type=template&id=573ca9fe"
import script from "./RankThisweekComponent.vue?vue&type=script&lang=js"
export * from "./RankThisweekComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__